import type { FeedbackStatus } from '../lib/types.js';

const LABELS: Record<FeedbackStatus, string> = {
  new: 'New',
  triaged: 'Triaged',
  planned: 'Planned',
  done: 'Done',
  declined: 'Declined',
};

/** Status is always paired with a text label, never color alone. */
export function StatusChip({ status }: { status: FeedbackStatus | string }) {
  const label = LABELS[status as FeedbackStatus] ?? status;
  return (
    <span class="chip" data-status={status}>
      {label}
    </span>
  );
}

export function StatusFilterChip({
  status,
  label,
  active,
  onClick,
}: {
  status: string;
  label: string;
  active: boolean;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      class={`chip chip-btn${active ? ' active' : ''}`}
      data-status={active ? status : undefined}
      onClick={onClick}
    >
      {label}
    </button>
  );
}
